<template>
    <div
        :class="[
            'component',
            'component__library_grid_item',
            checkboxActive ? 'component__library_grid_item--has-checkbox' : '',
            checkboxValue ? 'component__library_grid_item--checked' : '',
            item.error ? 'component__library_grid_item--error' : ''
            ]"
        tabindex="0"
        @keypress.space="performEmit"
        @keypress.enter="performEmit"
        @click="performEmit"
    >
        <div class="component__library_grid_item_box">
            <template v-if="checkboxActive">
                <div class="component__library_grid_item_box_checkbox">
                    <form-checkbox
                        :name="`component-library-grid-item-checkbox-${item.id}`"
                        :label="''"
                        :value="checkboxValue"
                        @input="performEmit"
                    />
                </div>
            </template>
            <div class="component__library_grid_item_box_thumbnail">
                <component-thumbnail
                    :id="item.id"
                    :alt="item.alt"
                    :loading="item.loading"
                    :error="item.error"
                />
            </div>
            <div class="component__library_grid_item_box_filename">{{ item.title }}</div>
        </div>
    </div>
</template>

<script>
import FormCheckbox from '@/components/default/forms/FormCheckbox'
import ComponentThumbnail from '@/components/default/shared/ComponentThumbnail'

export default {
  name: 'component-library-grid-item',
  components: { ComponentThumbnail, FormCheckbox },
  data () {
    return {
      checkboxValue: false
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    checkboxActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    performEmit () {
      if (this.checkboxActive) {
        this.emitCheck()
      } else {
        this.emitClick()
      }
    },
    emitCheck () {
      const value = !this.checkboxValue
      this.checkboxValue = value
      this.$emit('emit-check', { value: value, id: this.item.id })
    },
    emitClick () {
      this.$emit('emit-click', this.item.id)
    }
  },
  watch: {
    checkboxActive () {
      this.checkboxValue = false
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/_componentlibrarygriditem.scss";
</style>
